import { ReactSVG } from 'react-svg';
import cn from 'classnames';

import { importStatic } from 'utils';

import css from './dessertWithTumble.module.css';

const DesertWithTumbleweed = ({ viewportHeight = '200px', containerClassName = '' }) => {
  return (
    <div
      className={cn(
        css.container,
        'w-100 flex-fill d-flex justify-content-center overflow-hidden',
        containerClassName
      )}
    >
      <div className={cn(css['viewport'], 'd-flex position-relative')} style={{ height: viewportHeight }}>
        <ReactSVG
          src={importStatic('/ui-router/images/desertbgFix.svg')}
          className={cn(css['desert-bg'], 'm-auto')}
        />

        <div className={cn(css.shadow, 'position-absolute')} />

        <ReactSVG
          src={importStatic('/ui-router/images/tumbleweed.svg')}
          className={cn(css.tumbleweed, 'position-absolute w-max')}
        />
      </div>
    </div>
  );
};

export default DesertWithTumbleweed;